import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@softmax/design-system";

export type CoworldUsage = {
  readonly id: string;
  readonly name: string;
  readonly llm: string;
  readonly compute: string;
  readonly total: string;
};

export function UsageByCoworld({
  rows,
}: {
  readonly rows: readonly CoworldUsage[];
}) {
  return (
    <TableContainer aria-label="Usage by Coworld">
      <Table aria-label="Usage by Coworld">
        <TableHead>
          <TableRow>
            <TableHeaderCell scope="col">Coworld</TableHeaderCell>
            <TableHeaderCell scope="col" align="end">
              LLM
            </TableHeaderCell>
            <TableHeaderCell scope="col" align="end">
              Compute
            </TableHeaderCell>
            <TableHeaderCell scope="col" align="end">
              Total
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.name}</TableCell>
              <TableCell align="end">{row.llm}</TableCell>
              <TableCell align="end">{row.compute}</TableCell>
              <TableCell align="end">{row.total}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
